/**
 * Indonesian Translations (Nested Object Structure)
 * Default language for KinKen Kost Elite
 */

// Type definition for translations
export interface Translations {
  nav: {
    home: string;
    rooms: string;
    facilities: string;
    gallery: string;
    about: string;
    location: string;
    faq: string;
    contact: string;
    testimonials: string;
    career: string;
    bookNow: string;
    exploreMore: string;
    followUs: string;
    bookSanctuary: string;
    privacyPolicy: string;
    termsOfService: string;
    sitemap: string;
  };
  hero: {
    superText: string;
    title: string;
    titleHighlight: string;
    subtitle: string;
    cta: {
      explore: string;
      tour: string;
    };
    scrollText: string;
  };
  about: {
    tagline: string;
    title: string;
    description: string;
    cta: string;
  };
  rooms: {
    flexiStay: string;
    title: string;
    subtitle: string;
    viewDetails: string;
    more: string;
    daily: string;
    monthly: string;
    bestValue: string;
    mostPopular: string;
    exploreAll: string;
  };
  facilities: {
    tagline: string;
    title: string;
    subtitle: string;
    exploreAll: string;
  };
  gallery: {
    tagline: string;
    title: string;
    subtitle: string;
    exploreAll: string;
  };
  testimonials: {
    title: string;
    subtitle: string;
  };
  faq: {
    tagline: string;
    title: string;
    subtitle: string;
    badge: string;
    exploreAll: string;
  };
  contact: {
    tagline: string;
    title: string;
    description: string;
    detailsButton: string;
    fastResponse: string;
    formTagline: string;
    formTitle: string;
    formSubtitle: string;
    nameLabel: string;
    subjectLabel: string;
    messageLabel: string;
    messagePlaceholder: string;
    sendButton: string;
    sendButtonShort: string;
    processing: string;
    disclaimer: string;
    subjects: string[];
  };
  common: {
    learnMore: string;
    viewAll: string;
    backToHome: string;
    loading: string;
    error: string;
    tryAgain: string;
    close: string;
    open: string;
    language: string;
  };
}

const translations: Translations = {
  nav: {
    home: "Beranda",
    rooms: "Rooms & Suites",
    facilities: "Fasilitas",
    gallery: "Galeri",
    about: "Tentang KinKen",
    location: "Lokasi & Peta",
    faq: "FAQ Center",
    contact: "Hubungi Kami",
    testimonials: "Testimoni",
    career: "Karir",
    bookNow: "Pesan Sekarang",
    exploreMore: "Jelajahi Lebih",
    followUs: "Ikuti KinKen",
    bookSanctuary: "Pesan Hunian Anda",
    privacyPolicy: "Kebijakan Privasi",
    termsOfService: "Syarat & Ketentuan",
    sitemap: "Peta Situs",
  },
  hero: {
    superText: "Luxury Living Redefined",
    title: "Tinggal dengan",
    titleHighlight: "Kemewahan",
    subtitle: "KinKen Kost Elite menghadirkan standar baru hunian premium di Bali. Konsep kost pertama dengan layanan concierge 24/7, desain interior kurasi arsitek, dan fasilitas setara hotel bintang 5.",
    cta: {
      explore: "Jelajahi Hunian",
      tour: "Jadwalkan Tour",
    },
    scrollText: "Temukan Kemewahan Anda",
  },
  about: {
    tagline: "Tentang KinKen",
    title: "Lebih dari Sekadar Tempat Tinggal",
    description: "KinKen Kost Elite diciptakan untuk mereka yang menuntut lebih dari sekadar kamar kost. Kami menghadirkan filosofi 'luxury co-living' yang memadukan privasi personal dengan komunitas eksklusif.",
    cta: "Cerita Lengkap Kami",
  },
  rooms: {
    flexiStay: "Flexi-Stay Available",
    title: "Experience KinKen Living",
    subtitle: "Dari menginap semalam hingga tinggal jangka panjang, setiap kamar adalah sanctuary yang dirancang untuk profesional modern. Rasakan kemewahan setara hotel dengan privasi ruang pribadi Anda.",
    viewDetails: "Lihat Detail",
    more: "+Lainnya",
    daily: "Harian (Daily)",
    monthly: "Bulanan",
    bestValue: "Best Value",
    mostPopular: "Terpopuler",
    exploreAll: "Jelajahi Semua Kamar",
  },
  facilities: {
    tagline: "World Class Amenities",
    title: "Fasilitas Premium\nSesuai Standar Hotel Bintang 5.",
    subtitle: "Setiap fasilitas di KinKen dirancang untuk mendukung gaya hidup urban modern. Dari produktivitas hingga relaksasi, semua telah kami pikirkan.",
    exploreAll: "Jelajahi Semua Fasilitas",
  },
  gallery: {
    tagline: "The KinKen Experience",
    title: "Luxury in Every Frame.",
    subtitle: "Sebuah perjalanan visual melalui ruang-ruang premium KinKen. Setiap foto mengabadikan detail sempurna dari hunian elite yang dirancang untuk memanjakan indera dan menghadirkan ketenangan.",
    exploreAll: "Jelajahi Galeri Lengkap",
  },
  testimonials: {
    title: "Suara Ekselensi",
    subtitle: "Bergabunglah dengan komunitas global penghuni kami yang telah menjadikan KinKen sanctuary mereka di Bali. Temukan mengapa kami konsisten dinilai sebagai pengalaman luxury co-living terbaik di Bali.",
  },
  faq: {
    tagline: "FAQ CENTER",
    title: "Pertanyaan Umum",
    subtitle: "Jawaban untuk pertanyaan umum dari calon penghuni kami. Semua yang perlu Anda ketahui tentang luxury living experience di KinKen.",
    badge: "Fasilitas bintang 5 termasuk",
    exploreAll: "Lihat Semua FAQ",
  },
  contact: {
    tagline: "PREMIUM CONCIERGE",
    title: "Personalized Service",
    description: "Tim concierge 24/7 kami siap membantu dengan booking inquiries, virtual tour, atau personalized consultation untuk kebutuhan luxury living Anda di Bali.",
    detailsButton: "Contact & Location Details",
    fastResponse: "Fast Response Guarantee",
    formTagline: "INQUIRY FORM",
    formTitle: "Send Us a Message",
    formSubtitle: "Isi form di bawah untuk personalized response dari tim kami. Kami akan menghubungi Anda dalam 15 menit.",
    nameLabel: "Nama Lengkap",
    subjectLabel: "Subjek",
    messageLabel: "Pesan Anda",
    messagePlaceholder: "Mohon berikan detail pertanyaan Anda, tanggal check-in yang diinginkan, dan kebutuhan khusus lainnya...",
    sendButton: "Kirim Pesan ke Concierge",
    sendButtonShort: "Kirim Pesan",
    processing: "Memproses",
    disclaimer: "Dengan mengirim, Anda menyetujui kebijakan privasi kami. Waktu respons: 15 menit selama jam kerja.",
    subjects: [
      "Informasi Ketersediaan Kamar",
      "Private Viewing / Virtual Tour",
      "Long-stay Rates & Paket Spesial",
      "Corporate Partnership",
      "Pertanyaan Fasilitas & Amenities",
      "Informasi Umum / Lainnya",
    ],
  },
  common: {
    learnMore: "Pelajari Lebih Lanjut",
    viewAll: "Lihat Semua",
    backToHome: "Kembali ke Beranda",
    loading: "Memuat...",
    error: "Terjadi kesalahan",
    tryAgain: "Coba Lagi",
    close: "Tutup",
    open: "Buka",
    language: "Bahasa",
  },
};

export default translations;
